module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"sign-in-with-google":"Googleアカウントでサインイン","signed-in":"サインイン済み"},"en":{"sign-in-with-google":"Sign in with Google Account","signed-in":"Signed in"}}')
  delete Component.options._Ctor
}
